import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import {  Grid } from "@material-ui/core";
import Text from "../Text/Text";
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import clsx from 'clsx';


const useStyles = makeStyles((theme) => {
    const isDark = theme.palette.type === 'dark';
    return {
      modalHeader: (props) => {
        // const color = getPaletteColor(theme, props.variant);
        return {
          '&:first-child': {
            padding: theme.spacing(2),
          },
          //  background: theme.palette.primary.main,
          background: '#20419a',
           color: theme.palette.common.white,
        //   borderBottomColor: color,
          borderBottomStyle: 'solid',
          borderBottomWidth: 1,
          overflowY: 'visible',
          paddingBottom: theme.spacing(2),
        };
      },
      modalIcon: (props) => {
        const color =  theme.palette.text.primary;
        return {
          alignItems: 'center',
          color,
          display: 'flex',
        };
      },
      subtitle: (props) => {
        return {
          color: theme.palette.text.secondary,
        };
      },
  
     
    };
  });

  const usebaseModalContentStyles = makeStyles((theme) => ({
    content: (props) => ({
      padding: props.disablePadding ? 0 : theme.spacing(2),
    }),
  }));

  export const BaseModalContent = (props) => {
    const { disablePadding, className, ...rest } = props;
    const classes = usebaseModalContentStyles(props);
    return <DialogContent className={clsx(classes.content, className)} {...rest} />;
  };


const BaseModal=(props)=>{
    const {
        open,
        error,
        icon,
        onClose,
        title,
        titleVariant,
        alignTitle,
        hideCloseButton,
        subtext,
        disableBackdropClick,
        children,
        variant,
        className,
        ...remainingProps
    }=props
    const classes=useStyles();
    return(
        <>
 <Dialog open={open} onClose={onClose} disableBackdropClick={disableBackdropClick} {...remainingProps}>
      <DialogContent className={`${classes.modalHeader} ${className}`}>
        <Grid container spacing={1} alignItems="center">
          <Grid item>{icon && <div >{icon}</div>}</Grid>
          <Grid item xs>
            <Text  gutterBottom={false} variant={titleVariant || 'h5'} align={alignTitle}>
              {title}
            </Text>
          </Grid>
          <Grid item>
            {onClose && !hideCloseButton && (
              <IconButton aria-label="close" color="inherit" onClick={onClose} size="small">
                <Close />
              </IconButton>
            )}
          </Grid>
        </Grid>
        {subtext && (
          <Text fontSize="small" className={classes.subtitle}>
            {subtext}
          </Text>
        )}
      </DialogContent>
      {children}
    </Dialog>
        </>
    )
}
export { DialogContentText as BaseModalText };
export { DialogActions as BaseModalActions };
export default BaseModal;